// extracted by mini-css-extract-plugin
module.exports = {"reschedule-page__body":"_1MztSmehrv-nwjgC1eB31"};